import { fetchAndRetryIfServerBusy as fetch } from '@cvent/nucleus-networking';
import { FetchError } from './errors';

export { RequestBuilder } from '@cvent/nucleus-networking';
export async function fetchAndRetryIfServerBusy(request, ...rest) {
  try {
    return await fetch(request, ...rest);
  } catch (ex) {
    throw new FetchError(ex.message, typeof request === 'string' ? request : request.url);
  }
}
